import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { POINTSERV_STATUS_CODE_KEY } from 'shared/constants/pointserv';

const PointservCallbackContainer = () => {
  const { search } = useLocation();

  useEffect(() => {
    window.localStorage.setItem(POINTSERV_STATUS_CODE_KEY, queryString.parse(search).statusCode);
  }, []);

  return null;
};

export default PointservCallbackContainer;
